module.exports = __webpack_public_path__ + "static/media/tes.ca760593.png";